/**
 * @author ligai
 */
import response from '../../../../utils/response'
import Api from '../api'
import NP from 'number-precision'
import {projectInfo} from '../../../../utils'
import Store from '../../../../common/catch-state/store'
import Model from '../common/field-precision-currency'
Store.install(Model)

export const mixin = {
  data () {
    return {
      systemRules: {
        // 数字类型是否开启千分位
        numberThousandthPercentileEnabled: false,
        // 价格类型是否开启千分位
        priceThousandthPercentileEnabled: false,
        // 单价金额小数点后几位
        priceDecimalsPoint: null
      }
    }
  },
  async created () {
  },
  methods: {
    async getSystemRules () {
      const res = await Store.getThousandthPercentile('getSystemRulesKey').getter()
      if (!res) {
        return false
      }
      this.systemRules.priceThousandthPercentileEnabled = res['amount_unit_price_thousands_config'].value === '0'
      this.systemRules.numberThousandthPercentileEnabled = res['number_thousands_config'].value === '0'
    },
    formatPrice (value, ratio = 2, padding = false) {
      if (value === '' || value === 'undefined' || value === null) return null
      if (ratio === undefined || ratio === null) {
        return value
      } else {
        const result = parseFloat(NP.round(value, ratio))
        return padding ? result.toFixed(ratio) : result
      }
    },
    // 默认返回币种符号，filed获取需要的字段值
    getCurrencyFiled (currencyCode, filed) {
      if (currencyCode) {
        let target = this.currencyList.find(item => {
          return (item.currencyCode || item.code) === currencyCode
        })
        if (target) {
          if (filed) {
            return target[filed]
          } 
          return target.symbol || target.currencyCode || target.code
        }
      }
    },
    // 获取系统规则单价金额小数点后几位
    async getMoneyDecimalsPoint () {
      const api = Api.getListByRuleKey
      const params = [
        // 单价金额小数点后几位
        'money_decimals_point'
      ]
      const res = await response(this.$http(api.type, api.url, params))
      if (res.isOk) {
        this.systemRules.priceDecimalsPoint = res.content[params[0]]?.options.unitPriceBit || null
      }
    }
  }
}
